import { render, staticRenderFns } from "./DoctorPatientDetailView.vue?vue&type=template&id=0377d258&scoped=true"
import script from "./DoctorPatientDetailView.vue?vue&type=script&lang=js"
export * from "./DoctorPatientDetailView.vue?vue&type=script&lang=js"
import style0 from "./DoctorPatientDetailView.vue?vue&type=style&index=0&id=0377d258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0377d258",
  null
  
)

export default component.exports